// extracted by mini-css-extract-plugin
export default {"btnBox":"GetStarted_btnBox__Bs0OK","button":"GetStarted_button__Tkhdn"};